import { dateFormats } from './date'

/* eslint-disable no-extend-native */
declare global {
  export interface String {
    formatDate(): string | null
    isEmail(): boolean
    isEmpty(): boolean
    parseNumber(): number | null
    capitalize(): string
  }
}

String.prototype.formatDate = function formatDate (this: string): string | null {
  if (isNaN(Date.parse(this))) {
    return null
  }

  const date = new Date(this)

  return date.formatDate(dateFormats.ddMM)
}

String.prototype.isEmail = function (this: string): boolean {
  const pattern = '[a-zA-Z0-9_\\.\\+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-\\.]+'
  const regex = new RegExp(pattern)

  return !this.isEmpty() && regex.test(this)
}

String.prototype.isEmpty = function isEmpty (this: string): boolean {
  return this.trim().length <= 0
}

String.prototype.parseNumber = function (this: string): number | null {
  const number = Number.parseInt(this)

  return isNaN(number) ? null : number
}

String.prototype.capitalize = function (this: string): string {
  return this.charAt(0).toUpperCase() + this.slice(1)
}

export {}
